import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { Picklist } from '@groove-labs/groove-ui';
import {
  getReportFolderOptions,
  getAutoImportReportFolder,
} from 'Modules/PeopleImportDialog/submodules/reports/selectors';
import { requestFetchReports } from 'Modules/PeopleImportDialog/submodules/reports/actions';
import { AUTO_IMPORT_FIELDS } from 'Modules/FlowsShow/constants/index.ts';
import { resetFlowOwnerOptions } from 'Modules/FlowsShow/actions/fetchFlowOwnerOptions';

@connect(
  state => ({
    reportFolderOptions: getReportFolderOptions(state),
    defaultReportFolder: getAutoImportReportFolder(state),
  }),
  {
    fetchReports: requestFetchReports,
    resetFlowOwnerOptions,
  }
)
export default class ReportFolderPicklist extends PureComponent {
  static propTypes = {
    reportFolderOptions: ImmutablePropTypes.list.isRequired,
    defaultReportFolder: ImmutablePropTypes.map.isRequired,
    fetchReports: PropTypes.func.isRequired,
    resetFlowOwnerOptions: PropTypes.func.isRequired,

    // passed props
    groupId: PropTypes.string.isRequired,
    maxMenuHeight: PropTypes.number,
  };

  static defaultProps = {
    maxMenuHeight: null,
  };

  getLabel = option => option.get('name');

  handleReportFolderSelect = folder => {
    const { groupId, fetchReports, resetFlowOwnerOptions } = this.props;

    fetchReports({ groupId, reportFolder: folder });
    resetFlowOwnerOptions();
  };

  render() {
    const { groupId, reportFolderOptions, defaultReportFolder, maxMenuHeight } =
      this.props;

    return (
      <Picklist
        groupId={groupId}
        fieldId={AUTO_IMPORT_FIELDS.FOLDERS}
        label="Choose a Folder"
        options={reportFolderOptions}
        getOptionLabel={this.getLabel}
        onChange={this.handleReportFolderSelect}
        initialValue={!defaultReportFolder.isEmpty() && defaultReportFolder}
        maxMenuHeight={maxMenuHeight}
      />
    );
  }
}
